"use strict";

require("core-js/modules/esnext.global-this.js");
function e(e) {
  return e && "object" == typeof e && "default" in e ? e.default : e;
}
Object.defineProperty(exports, "__esModule", {
  value: !0
});
var t = require("react"),
  r = e(t),
  n = e(require("use-deep-compare-effect")),
  o = function o(e) {
    return "apollo-embed-" + e;
  };
function i(e, t, r, n, o, i, a) {
  try {
    var s = e[i](a),
      l = s.value;
  } catch (e) {
    return void r(e);
  }
  s.done ? t(l) : Promise.resolve(l).then(n, o);
}
function a() {
  return (a = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) {
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
    }
    return e;
  }).apply(this, arguments);
}
var s,
  l = (function (e) {
    var t = function (e) {
      var t = Object.prototype,
        r = t.hasOwnProperty,
        n = "function" == typeof Symbol ? Symbol : {},
        o = n.iterator || "@@iterator",
        i = n.asyncIterator || "@@asyncIterator",
        a = n.toStringTag || "@@toStringTag";
      function s(e, t, r) {
        return Object.defineProperty(e, t, {
          value: r,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }), e[t];
      }
      try {
        s({}, "");
      } catch (e) {
        s = function s(e, t, r) {
          return e[t] = r;
        };
      }
      function l(e, t, r, n) {
        var o = Object.create((t && t.prototype instanceof d ? t : d).prototype),
          i = new I(n || []);
        return o._invoke = function (e, t, r) {
          var n = "suspendedStart";
          return function (o, i) {
            if ("executing" === n) throw new Error("Generator is already running");
            if ("completed" === n) {
              if ("throw" === o) throw i;
              return {
                value: void 0,
                done: !0
              };
            }
            for (r.method = o, r.arg = i;;) {
              var a = r.delegate;
              if (a) {
                var s = E(a, r);
                if (s) {
                  if (s === u) continue;
                  return s;
                }
              }
              if ("next" === r.method) r.sent = r._sent = r.arg;else if ("throw" === r.method) {
                if ("suspendedStart" === n) throw n = "completed", r.arg;
                r.dispatchException(r.arg);
              } else "return" === r.method && r.abrupt("return", r.arg);
              n = "executing";
              var l = c(e, t, r);
              if ("normal" === l.type) {
                if (n = r.done ? "completed" : "suspendedYield", l.arg === u) continue;
                return {
                  value: l.arg,
                  done: r.done
                };
              }
              "throw" === l.type && (n = "completed", r.method = "throw", r.arg = l.arg);
            }
          };
        }(e, r, i), o;
      }
      function c(e, t, r) {
        try {
          return {
            type: "normal",
            arg: e.call(t, r)
          };
        } catch (e) {
          return {
            type: "throw",
            arg: e
          };
        }
      }
      e.wrap = l;
      var u = {};
      function d() {}
      function p() {}
      function h() {}
      var m = {};
      s(m, o, function () {
        return this;
      });
      var f = Object.getPrototypeOf,
        v = f && f(f(S([])));
      v && v !== t && r.call(v, o) && (m = v);
      var g = h.prototype = d.prototype = Object.create(m);
      function y(e) {
        ["next", "throw", "return"].forEach(function (t) {
          s(e, t, function (e) {
            return this._invoke(t, e);
          });
        });
      }
      function b(e, t) {
        var n;
        this._invoke = function (o, i) {
          function a() {
            return new t(function (n, a) {
              !function n(o, i, a, s) {
                var l = c(e[o], e, i);
                if ("throw" !== l.type) {
                  var u = l.arg,
                    d = u.value;
                  return d && "object" == typeof d && r.call(d, "__await") ? t.resolve(d.__await).then(function (e) {
                    n("next", e, a, s);
                  }, function (e) {
                    n("throw", e, a, s);
                  }) : t.resolve(d).then(function (e) {
                    u.value = e, a(u);
                  }, function (e) {
                    return n("throw", e, a, s);
                  });
                }
                s(l.arg);
              }(o, i, n, a);
            });
          }
          return n = n ? n.then(a, a) : a();
        };
      }
      function E(e, t) {
        var r = e.iterator[t.method];
        if (void 0 === r) {
          if (t.delegate = null, "throw" === t.method) {
            if (e.iterator.return && (t.method = "return", t.arg = void 0, E(e, t), "throw" === t.method)) return u;
            t.method = "throw", t.arg = new TypeError("The iterator does not provide a 'throw' method");
          }
          return u;
        }
        var n = c(r, e.iterator, t.arg);
        if ("throw" === n.type) return t.method = "throw", t.arg = n.arg, t.delegate = null, u;
        var o = n.arg;
        return o ? o.done ? (t[e.resultName] = o.value, t.next = e.nextLoc, "return" !== t.method && (t.method = "next", t.arg = void 0), t.delegate = null, u) : o : (t.method = "throw", t.arg = new TypeError("iterator result is not an object"), t.delegate = null, u);
      }
      function w(e) {
        var t = {
          tryLoc: e[0]
        };
        1 in e && (t.catchLoc = e[1]), 2 in e && (t.finallyLoc = e[2], t.afterLoc = e[3]), this.tryEntries.push(t);
      }
      function x(e) {
        var t = e.completion || {};
        t.type = "normal", delete t.arg, e.completion = t;
      }
      function I(e) {
        this.tryEntries = [{
          tryLoc: "root"
        }], e.forEach(w, this), this.reset(!0);
      }
      function S(e) {
        if (e) {
          var t = e[o];
          if (t) return t.call(e);
          if ("function" == typeof e.next) return e;
          if (!isNaN(e.length)) {
            var n = -1,
              i = function t() {
                for (; ++n < e.length;) {
                  if (r.call(e, n)) return t.value = e[n], t.done = !1, t;
                }
                return t.value = void 0, t.done = !0, t;
              };
            return i.next = i;
          }
        }
        return {
          next: R
        };
      }
      function R() {
        return {
          value: void 0,
          done: !0
        };
      }
      return p.prototype = h, s(g, "constructor", h), s(h, "constructor", p), p.displayName = s(h, a, "GeneratorFunction"), e.isGeneratorFunction = function (e) {
        var t = "function" == typeof e && e.constructor;
        return !!t && (t === p || "GeneratorFunction" === (t.displayName || t.name));
      }, e.mark = function (e) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(e, h) : (e.__proto__ = h, s(e, a, "GeneratorFunction")), e.prototype = Object.create(g), e;
      }, e.awrap = function (e) {
        return {
          __await: e
        };
      }, y(b.prototype), s(b.prototype, i, function () {
        return this;
      }), e.AsyncIterator = b, e.async = function (t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new b(l(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function (e) {
          return e.done ? e.value : a.next();
        });
      }, y(g), s(g, a, "Generator"), s(g, o, function () {
        return this;
      }), s(g, "toString", function () {
        return "[object Generator]";
      }), e.keys = function (e) {
        var t = [];
        for (var r in e) {
          t.push(r);
        }
        return t.reverse(), function r() {
          for (; t.length;) {
            var n = t.pop();
            if (n in e) return r.value = n, r.done = !1, r;
          }
          return r.done = !0, r;
        };
      }, e.values = S, I.prototype = {
        constructor: I,
        reset: function reset(e) {
          if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(x), !e) for (var t in this) {
            "t" === t.charAt(0) && r.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = void 0);
          }
        },
        stop: function stop() {
          this.done = !0;
          var e = this.tryEntries[0].completion;
          if ("throw" === e.type) throw e.arg;
          return this.rval;
        },
        dispatchException: function dispatchException(e) {
          if (this.done) throw e;
          var t = this;
          function n(r, n) {
            return a.type = "throw", a.arg = e, t.next = r, n && (t.method = "next", t.arg = void 0), !!n;
          }
          for (var o = this.tryEntries.length - 1; o >= 0; --o) {
            var i = this.tryEntries[o],
              a = i.completion;
            if ("root" === i.tryLoc) return n("end");
            if (i.tryLoc <= this.prev) {
              var s = r.call(i, "catchLoc"),
                l = r.call(i, "finallyLoc");
              if (s && l) {
                if (this.prev < i.catchLoc) return n(i.catchLoc, !0);
                if (this.prev < i.finallyLoc) return n(i.finallyLoc);
              } else if (s) {
                if (this.prev < i.catchLoc) return n(i.catchLoc, !0);
              } else {
                if (!l) throw new Error("try statement without catch or finally");
                if (this.prev < i.finallyLoc) return n(i.finallyLoc);
              }
            }
          }
        },
        abrupt: function abrupt(e, t) {
          for (var n = this.tryEntries.length - 1; n >= 0; --n) {
            var o = this.tryEntries[n];
            if (o.tryLoc <= this.prev && r.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
              var i = o;
              break;
            }
          }
          i && ("break" === e || "continue" === e) && i.tryLoc <= t && t <= i.finallyLoc && (i = null);
          var a = i ? i.completion : {};
          return a.type = e, a.arg = t, i ? (this.method = "next", this.next = i.finallyLoc, u) : this.complete(a);
        },
        complete: function complete(e, t) {
          if ("throw" === e.type) throw e.arg;
          return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && t && (this.next = t), u;
        },
        finish: function finish(e) {
          for (var t = this.tryEntries.length - 1; t >= 0; --t) {
            var r = this.tryEntries[t];
            if (r.finallyLoc === e) return this.complete(r.completion, r.afterLoc), x(r), u;
          }
        },
        catch: function _catch(e) {
          for (var t = this.tryEntries.length - 1; t >= 0; --t) {
            var r = this.tryEntries[t];
            if (r.tryLoc === e) {
              var n = r.completion;
              if ("throw" === n.type) {
                var o = n.arg;
                x(r);
              }
              return o;
            }
          }
          throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, t, r) {
          return this.delegate = {
            iterator: S(e),
            resultName: t,
            nextLoc: r
          }, "next" === this.method && (this.arg = void 0), u;
        }
      }, e;
    }(e.exports);
    try {
      regeneratorRuntime = t;
    } catch (e) {
      "object" == typeof globalThis ? globalThis.regeneratorRuntime = t : Function("r", "regeneratorRuntime = r")(t);
    }
  }(s = {
    exports: {}
  }), s.exports);
function c(e) {
  var t,
    r = e.embeddedIFrameElement;
  null == r || null == (t = r.contentWindow) || t.postMessage(e.message, e.embedUrl);
}
var u = 0,
  d = function () {
    function e(e) {
      var t,
        r,
        n = this;
      this.getEmbeddedExplorerURL = function () {
        var e,
          t,
          r = n.options.initialState || {},
          o = r.document,
          i = r.variables,
          a = r.headers,
          s = r.displayOptions,
          l = n.options.persistExplorerState,
          c = {
            graphRef: "graphRef" in n.options ? n.options.graphRef : void 0,
            document: o ? encodeURIComponent(o) : void 0,
            variables: i ? encodeURIComponent(JSON.stringify(i)) : void 0,
            headers: a ? encodeURIComponent(JSON.stringify(a)) : void 0,
            shouldPersistState: !!l,
            docsPanelState: null != (e = null == s ? void 0 : s.docsPanelState) ? e : "open",
            showHeadersAndEnvVars: !1 !== (null == s ? void 0 : s.showHeadersAndEnvVars),
            theme: null != (t = null == s ? void 0 : s.theme) ? t : "dark",
            shouldShowGlobalHeader: !0,
            parentSupportsSubscriptions: !1
          };
        return "https://explorer.embed.apollographql.com?" + Object.entries(c).filter(function (e) {
          return void 0 !== e[1];
        }).map(function (e) {
          return e[0] + "=" + e[1];
        }).join("&");
      }, this.options = e, this.validateOptions(), this.handleRequest = null != (t = this.options.handleRequest) ? t : (r = !!this.options.includeCookies, function (e, t) {
        return fetch(e, a({}, t, r ? {
          credentials: "include"
        } : {}));
      }), this.uniqueEmbedInstanceId = u++, this.embeddedExplorerURL = this.getEmbeddedExplorerURL(), this.embeddedExplorerIFrameElement = this.injectEmbed(), this.disposable = function (e) {
        var t = e.endpointUrl,
          r = e.handleRequest,
          n = e.embeddedExplorerIFrameElement,
          o = e.updateSchemaInEmbed,
          s = e.schema,
          u = e.graphRef,
          d = e.autoInviteOptions,
          p = "https://explorer.embed.apollographql.com",
          h = function h(e) {
            !function (e) {
              var t = e.embeddedIFrameElement,
                r = e.embedUrl,
                n = e.event.data;
              if ("SetPartialAuthenticationTokenForParent" === n.name) {
                var o = window.localStorage.getItem("apolloStudioEmbeddedExplorerEncodedApiKey"),
                  i = o ? JSON.parse(o) : {};
                i[n.localStorageKey] = n.partialToken, window.localStorage.setItem("apolloStudioEmbeddedExplorerEncodedApiKey", JSON.stringify(i));
              }
              if ("TriggerLogoutInParent" === n.name) {
                var a = window.localStorage.getItem("apolloStudioEmbeddedExplorerEncodedApiKey"),
                  s = a ? JSON.parse(a) : {};
                delete s[n.localStorageKey], window.localStorage.setItem("apolloStudioEmbeddedExplorerEncodedApiKey", JSON.stringify(s)), c({
                  message: {
                    name: "ParentLogoutSuccess"
                  },
                  embeddedIFrameElement: t,
                  embedUrl: r
                });
              }
              if ("ExplorerListeningForPartialToken" === n.name && n.localStorageKey) {
                var l = window.localStorage.getItem("apolloStudioEmbeddedExplorerEncodedApiKey"),
                  u = l ? JSON.parse(l) : {};
                u && u[n.localStorageKey] && c({
                  message: {
                    name: "PartialAuthenticationTokenResponse",
                    partialToken: u[n.localStorageKey]
                  },
                  embeddedIFrameElement: t,
                  embedUrl: r
                });
              }
            }({
              event: e,
              embedUrl: p,
              embeddedIFrameElement: n
            });
            var h = "object" == typeof e.data ? e.data : void 0;
            if (h && "name" in h) {
              "ExplorerListeningForHandshake" === h.name && c({
                message: {
                  name: "HandshakeResponse",
                  graphRef: u,
                  inviteToken: null == d ? void 0 : d.inviteToken,
                  accountId: null == d ? void 0 : d.accountId
                },
                embeddedIFrameElement: n,
                embedUrl: p
              }), "ExplorerListeningForSchema" === h.name && s && o({
                schema: s
              });
              var m = "ExplorerRequest" === h.name;
              m && h.operation && h.operationId && m && function (e) {
                var t,
                  r,
                  n = e.operation,
                  o = e.operationName,
                  s = e.variables,
                  u = e.embeddedIFrameElement,
                  d = e.operationId,
                  p = e.embedUrl;
                (0, e.handleRequest)(e.endpointUrl, {
                  method: "POST",
                  headers: (t = e.headers, r = null != t ? t : {}, Object.keys(r).every(function (e) {
                    return "content-type" !== e.toLowerCase();
                  }) && (r["content-type"] = "application/json"), r),
                  body: JSON.stringify({
                    query: n,
                    variables: s,
                    operationName: o
                  })
                }).then(function () {
                  var e,
                    t = (e = l.mark(function e(t) {
                      var r, n;
                      return l.wrap(function (e) {
                        for (;;) {
                          switch (e.prev = e.next) {
                            case 0:
                              return e.next = 2, t.json();
                            case 2:
                              r = e.sent, n = {}, t.headers.forEach(function (e, t) {
                                n[t] = e;
                              }), c({
                                message: {
                                  name: "ExplorerResponse",
                                  operationId: d,
                                  response: a({}, r, {
                                    status: t.status,
                                    headers: n
                                  })
                                },
                                embeddedIFrameElement: u,
                                embedUrl: p
                              });
                            case 6:
                            case "end":
                              return e.stop();
                          }
                        }
                      }, e);
                    }), function () {
                      var t = this,
                        r = arguments;
                      return new Promise(function (n, o) {
                        var a = e.apply(t, r);
                        function s(e) {
                          i(a, n, o, s, l, "next", e);
                        }
                        function l(e) {
                          i(a, n, o, s, l, "throw", e);
                        }
                        s(void 0);
                      });
                    });
                  return function (e) {
                    return t.apply(this, arguments);
                  };
                }()).catch(function (e) {
                  c({
                    message: {
                      name: "ExplorerResponse",
                      operationId: d,
                      response: {
                        error: a({
                          message: e.message
                        }, e.stack ? {
                          stack: e.stack
                        } : {})
                      }
                    },
                    embeddedIFrameElement: u,
                    embedUrl: p
                  });
                });
              }({
                endpointUrl: t,
                handleRequest: r,
                operation: h.operation,
                operationName: h.operationName,
                variables: h.variables,
                headers: h.headers,
                embeddedIFrameElement: n,
                operationId: h.operationId,
                embedUrl: p
              });
            }
          };
        return window.addEventListener("message", h), {
          dispose: function dispose() {
            return window.removeEventListener("message", h);
          }
        };
      }({
        embeddedExplorerIFrameElement: this.embeddedExplorerIFrameElement,
        endpointUrl: this.options.endpointUrl,
        handleRequest: this.handleRequest,
        updateSchemaInEmbed: this.updateSchemaInEmbed.bind(this),
        schema: "schema" in this.options ? this.options.schema : void 0,
        graphRef: "graphRef" in this.options ? this.options.graphRef : void 0,
        autoInviteOptions: this.options.autoInviteOptions
      });
    }
    var t = e.prototype;
    return t.dispose = function () {
      var e;
      null == (e = document.getElementById(o(this.uniqueEmbedInstanceId))) || e.remove(), this.disposable.dispose();
    }, t.injectEmbed = function () {
      var e,
        t,
        r,
        n = this.options.target;
      t = "string" == typeof n ? null == (r = document) || null == r.querySelector ? void 0 : r.querySelector(n) : n;
      var i = document.createElement("iframe");
      return i.src = this.embeddedExplorerURL, i.id = o(this.uniqueEmbedInstanceId), i.setAttribute("style", "height: 100%; width: 100%; border: none;"), null == (e = t) || e.appendChild(i), i;
    }, t.validateOptions = function () {
      if (!this.options.target) throw new Error('"target" is required');
      if (!this.options.handleRequest && !this.options.endpointUrl) throw new Error("`endpointUrl` is required unless you write a custom `handleRequest`");
      if ("schema" in this.options && "graphRef" in this.options) throw new Error("Both `schema` and `graphRef` cannot be set. You can either send your schema as an IntrospectionQuery or string via the `schema` field, or specifiy a public graphRef.");
      if (!("schema" in this.options) && !("graphRef" in this.options)) throw new Error("You must set either `schema` or `graphRef`.");
    }, t.updateSchemaInEmbed = function (e) {
      c({
        message: {
          name: "SchemaResponse",
          schema: e.schema
        },
        embeddedIFrameElement: this.embeddedExplorerIFrameElement,
        embedUrl: "https://explorer.embed.apollographql.com"
      });
    }, e;
  }();
exports.ApolloExplorer = d, exports.ApolloExplorerReact = function (e) {
  var o = t.useState(),
    i = o[0],
    s = o[1],
    l = t.useRef(),
    c = e.initialState,
    u = e.autoInviteOptions,
    p = e.className,
    h = e.schema;
  return n(function () {
    var t;
    if (i) return null == (t = l.current) || t.dispose(), l.current = new d(a({}, e, {
      target: i
    })), function () {
      var e;
      return null == (e = l.current) ? void 0 : e.dispose();
    };
  }, [e.endpointUrl, e.handleRequest, void 0 === c ? {} : c, e.persistExplorerState, e.graphRef, void 0 === u ? {} : u, e.includeCookies, p, i]), t.useEffect(function () {
    var e;
    h && (null == (e = l.current) || e.updateSchemaInEmbed({
      schema: h
    }));
  }, [h, l.current]), r.createElement("div", {
    className: p,
    ref: function ref(e) {
      s(e);
    }
  });
};